import React, { Component, createRef } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

// Импорт стилей Swiper
import 'swiper/css'
import 'swiper/css/navigation'

class App extends Component {
  constructor(props) {
    super(props)
    this.swiperRef = createRef()
    this.state = {
      isBeginning: true,
      isEnd: false
    }
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    })
  }

  render() {
    const { data } = this.props
    const { block_feedback } = data
    const { isBeginning, isEnd } = this.state

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.485 8.09251V11.0925C13.485 11.2875 13.4775 11.475 13.455 11.655C13.2825 13.68 12.09 14.685 9.8925 14.685H9.59251C9.40501 14.685 9.225 14.775 9.1125 14.925L8.21251 16.125C7.81501 16.6575 7.17 16.6575 6.7725 16.125L5.87249 14.925C5.77499 14.7975 5.5575 14.685 5.3925 14.685H5.09251C2.70001 14.685 1.5 14.0925 1.5 11.0925V8.09251C1.5 5.89501 2.51251 4.70251 4.53001 4.53001C4.71001 4.50751 4.89751 4.5 5.09251 4.5H9.8925C12.285 4.5 13.485 5.70001 13.485 8.09251Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.4863 5.09251V8.09251C16.4863 10.2975 15.4737 11.4825 13.4562 11.655C13.4787 11.475 13.4863 11.2875 13.4863 11.0925V8.09251C13.4863 5.70001 12.2862 4.5 9.89375 4.5H5.09375C4.89875 4.5 4.71125 4.50751 4.53125 4.53001C4.70375 2.51251 5.89625 1.5 8.09375 1.5H12.8937C15.2862 1.5 16.4863 2.70001 16.4863 5.09251Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.1216 9.9375H10.1284" stroke="#032432" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.49662 9.9375H7.50337" stroke="#032432" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.87162 9.9375H4.87837" stroke="#032432" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Отзывы</div>
            </div>
          </div>
          
          <div className='flex flex-col xl:flex-row items-center xl:items-end justify-between gap-[20px]'>
            <div>
              <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(block_feedback?.title)}</h2>
              <div className='mt-[10px] text-[14px] xl:text-[16px] text-black/60 text-center xl:text-start tracking-[-0.02em]'>{Parser(block_feedback?.text)}</div>
            </div>
            
            <div className='flex items-center gap-[10px]'>
              <a href={block_feedback?.yalink} className='flex items-center gap-[7px] px-[16px] rounded-full bg-[#009EE3] h-[38px] text-white text-[14px]'>
                <div>Больше отзывов на Я.Карты</div>
                <img src={block_feedback?.yaicon} alt="ya" width={24} height={24} />
              </a>
              
              {/* Кастомная навигация с полупрозрачностью */}
              <div className='flex items-center gap-[5px]'>
                <div 
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !isBeginning && this.swiperRef.current?.slidePrev()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.75269 0.25L0.577271 5.75L3.75269 11.25" stroke="white"/>
                  </svg>
                </div>
                <div 
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !isEnd && this.swiperRef.current?.slideNext()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="white"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Слайдер с отзывами */}
          <div className='mt-[20px]'>
            <Swiper
              onSwiper={(swiper) => {
                this.swiperRef.current = swiper
                this.handleSlideChange(swiper)
              }}
              onSlideChange={this.handleSlideChange}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={3}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 10
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 10
                }
              }}
              className='feedback-slider'
            >
              {(block_feedback?.cards || []).map((elm, index) => (
                <SwiperSlide key={index}>
                  <div className='rounded-[15px] bg-[#F5F7F9] p-[20px] h-full xl:min-h-[167px]'>
                    <div className='flex justify-between items-center'>
                      <div className='text-[#032432] text-[16px] xl:text-[18px]'>{elm.name}</div>
                      <div className='flex items-center text-[#032432] text-[16px] xl:text-[18px]'>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.48376 0.690722C6.78311 -0.230589 8.08652 -0.230588 8.38587 0.690722L9.45544 3.98252C9.58931 4.39454 9.97327 4.6735 10.4065 4.6735H13.8677C14.8364 4.6735 15.2392 5.91312 14.4555 6.48252L11.6553 8.51696C11.3048 8.7716 11.1582 9.22297 11.292 9.63499L12.3616 12.9268C12.661 13.8481 11.6065 14.6142 10.8228 14.0448L8.0226 12.0104C7.67211 11.7557 7.19752 11.7557 6.84703 12.0104L4.04686 14.0448C3.26315 14.6142 2.20867 13.8481 2.50802 12.9268L3.57759 9.63499C3.71146 9.22297 3.5648 8.7716 3.21432 8.51696L0.414147 6.48252C-0.369566 5.91312 0.0332093 4.6735 1.00193 4.6735H4.46313C4.89636 4.6735 5.28031 4.39454 5.41419 3.98252L6.48376 0.690722Z" fill="#032432"/>
                        </svg>
                        <div className='mr-[5px]'>{elm.rating}</div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H12" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M15.1997 4.61959C14.8697 3.62959 15.2597 2.40959 16.3397 2.06959C16.8997 1.89959 17.5997 2.03959 17.9997 2.56959C18.3797 2.01959 19.0997 1.89959 19.6597 2.06959C20.7397 2.39959 21.1297 3.62959 20.7997 4.61959C20.2897 6.18959 18.4997 6.99959 17.9997 6.99959C17.4997 6.99959 15.7297 6.19959 15.1997 4.61959Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M15.9945 11H16.0035" stroke="#009EE3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M11.9945 11H12.0035" stroke="#009EE3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M7.99451 11H8.00349" stroke="#009EE3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <div className='mt-[7px] text-[14px] xl:text-[16px] leading-3 xl:leading-4 text-black/60 tracking-[-0.02em]'>{Parser(elm.text)}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  }
}

export default App